import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addrepresentative, addrepresentative2, addrepresentative3 } from "../redux/blacklist";

const Representatives = () => {
    const [show, setShow] = useState(false);
    const [showAnother, setShowAnother] = useState(false);
    const [edit1, setEdit1] = useState(false);
    const [edit2, setEdit2] = useState(false);
    const [edit3, setEdit3] = useState(false);



    const [type, setType] = useState('');
    const [typeother, setTypeOther] = useState('');
    const [title, setTitle] = useState('');
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastName] = useState('');
    const [marital, setMarital] = useState('');
    const [IDtype, setIDtype] = useState('Smart Card');
    const [ID, setID] = useState('');

    const [birthdate, setBirthDate] = useState('');
    const [sex, setSex] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    const [currentRep, setCurrentRep] = useState(1);

    const dispatch = useDispatch();

    const blacklist = useSelector((state) => state.blacklist.value)



    const changeRepresentative = (current_rep, edit1, edit2, edit3) => {
        if (edit1) {
            dispatch(addrepresentative({
                type,
                typeother,
                title,
                firstname,
                lastname,
                marital,
                IDtype,
                ID,
                birthdate,
                sex,
                email,
                phone
                })) 
        } else if (edit2) {
            dispatch(addrepresentative2({
                type,
                typeother,
                title,
                firstname,
                lastname,
                marital,
                IDtype,
                ID,
                birthdate,
                sex,
                email,
                phone
                })) 
        } else if (edit3) {
            dispatch(addrepresentative3({
                type,
                typeother,
                title,
                firstname,
                lastname,
                marital,
                IDtype,
                ID,
                birthdate,
                sex,
                email,
                phone
                })) 
        } else if (current_rep === 1) {
           dispatch(addrepresentative({
            type,
            typeother,
            title,
            firstname,
            lastname,
            marital,
            IDtype,
            ID,
            birthdate,
            sex,
            email,
            phone
            })) 
        } else if (current_rep === 2) {
            dispatch(addrepresentative2({
             type,
             typeother,
             title,
             firstname,
             lastname,
             marital,
             IDtype,
             ID,
             birthdate,
             sex,
             email,
             phone
             })) 
         } else if (current_rep === 3) {
            dispatch(addrepresentative3({
             type,
             typeother,
             title,
             firstname,
             lastname,
             marital,
             IDtype,
             ID,
             birthdate,
             sex,
             email,
             phone
             })) 
         }
        
    }

    useEffect(() => {
        changeRepresentative(currentRep, edit1, edit2, edit3)
    }, [type, typeother, title, firstname, lastname, marital, IDtype, ID, birthdate,sex, email, phone])

    return ( 
        <section className="my-4" id="representatives"> 
            {
                !show && !showAnother &&
                <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-outline-secondary" onClick={(e) => {
                    if (show) {
                        setShow(false)
                    } else {
                        setShow(true)
                    }
                }}>Add Company Representative</button>    
            </div>
            }
            {
                currentRep > 1 &&
                <button className="btn btn-outline-info" onClick={(e) => {
                    e.preventDefault();
                    
                    setEdit1(true);
                    setEdit2(false);
                    setEdit3(false);

                    setType(blacklist.representative.type);
                    setTypeOther(blacklist.representative.typeother);
                    setTitle(blacklist.representative.title);
                    setFirstName(blacklist.representative.firstname);
                    setLastName(blacklist.representative.lastname);
                    setMarital(blacklist.representative.marital);
                    setIDtype(blacklist.representative.IDtype);
                    setID(blacklist.representative.ID);
                    setBirthDate(blacklist.representative.birthdate);
                    setSex(blacklist.representative.sex);
                    setEmail(blacklist.representative.email);
                    setPhone(blacklist.representative.phone);
                }}>
                    representative 1:<br/>
                    {blacklist.representative.firstname} {blacklist.representative.lastname}
                </button>
            }
            {
                currentRep > 2 &&
                <button className="btn btn-outline-info mx-3" onClick={(e) => {
                    e.preventDefault();
                    
                    setEdit1(false);
                    setEdit2(true);
                    setEdit3(false);

                    setType(blacklist.representative2.type);
                    setTypeOther(blacklist.representative2.typeother);
                    setTitle(blacklist.representative2.title);
                    setFirstName(blacklist.representative2.firstname);
                    setLastName(blacklist.representative2.lastname);
                    setMarital(blacklist.representative2.marital);
                    setIDtype(blacklist.representative2.IDtype);
                    setID(blacklist.representative2.ID);
                    setBirthDate(blacklist.representative2.birthdate);
                    setSex(blacklist.representative2.sex);
                    setEmail(blacklist.representative2.email);
                    setPhone(blacklist.representative2.phone);
                }}>
                    representative 2:<br/>
                    {blacklist.representative2.firstname} {blacklist.representative2.lastname}
                </button>
            }
            {
                currentRep > 3 &&
                <button className="btn btn-outline-info" onClick={(e) => {
                    e.preventDefault();
                    
                    setEdit1(false);
                    setEdit2(false);
                    setEdit3(true);

                    setType(blacklist.representative3.type);
                    setTypeOther(blacklist.representative3.typeother);
                    setTitle(blacklist.representative3.title);
                    setFirstName(blacklist.representative3.firstname);
                    setLastName(blacklist.representative3.lastname);
                    setMarital(blacklist.representative3.marital);
                    setIDtype(blacklist.representative3.IDtype);
                    setID(blacklist.representative3.ID);
                    setBirthDate(blacklist.representative3.birthdate);
                    setSex(blacklist.representative3.sex);
                    setEmail(blacklist.representative3.email);
                    setPhone(blacklist.representative3.phone);
                }}>
                    representative 3:<br/>
                    {blacklist.representative3.firstname} {blacklist.representative3.lastname}
                </button>
            }
            
            {showAnother && currentRep < 4 &&
                <button className="btn btn-success m-3" onClick={(e) => {
                    e.preventDefault();
                    setShow(true);
                }}> Add</button>
            }
            {show &&
            <div>
                <h2 className="display-6 text-center text-muted my-3">Company Representatives</h2>

                <h4 className="text-center">Representatives Details</h4>


                <select name="representative-type" class="form-select my-3" onChange={(e) => {
                    setType(e.target.value)
                }} value={type}>
                    <option selected>Representative type <span className="text-danger">*</span></option>
                    <option value="Director">Director</option>
                    <option value="Shareholder">Shareholder</option>
                    <option value="Employee">Employee</option>
                    <option value="Surety">Surety</option>
                    <option value="Other">Other</option>
                </select>

                <label htmlFor="other" className="form-label ms-3">If other, please specify</label>
                <input type="text" className="form-control w-50 ms-3" onChange={(e) => {
                    setTypeOther(e.target.value)
                }} value={typeother}/>
                
                <div className="d-flex">
                    <div>
                    <label htmlFor="title" className="form-label">Title: <span className="text-danger">*</span></label>
                    <select name="title" class="form-select" onChange={(e) => {
                        setTitle(e.target.value)
                    }} value={title}>
                        <option selected value="Unspecified"></option>
                        <option value="Mr.">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Miss.">Miss.</option>
                        <option value="Dr.">Dr.</option>
                        <option value="Adv.">Adv.</option>
                        <option value="Other">Other</option>
                    </select>
                    </div>
                    <div className="ms-3">
                        <label htmlFor="sex" className="form-label">Gender: <span className="text-danger">*</span></label>
                    
                        <select name="sex" id="" className="form-select" onChange={(e) => {
                            setSex(e.target.value)
                        }} value={sex}>
                            <option selected value="Unspecified"></option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Unknown">Unknown</option>
                        </select>
                    </div>

                </div>

                
                


                <div className="d-flex flex-wrap">
                    <div className="me-2">
                        <label for="firstname" className="form-label">First name: <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" onChange={(e) => {
                            setFirstName(e.target.value)
                        }} value={firstname}/>
                    </div>
                </div>
                

                <label for="lastname" className="form-label">Last name: <span className="text-danger">*</span></label>
                <input type="text" className="form-control" onChange={(e) => {
                    setLastName(e.target.value)
                }} value={lastname}/>

                <select name="marital" className="form-select w-50 mt-3" onChange={(e) => {
                    setMarital(e.target.value)
                }} value={marital}>
                    <option selected value="Not selected">Marital Status <span className="text-danger">*</span></option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Engaged">Engaged</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Unknown">Unknown</option>
                </select>

                



                <label for='ID' className="form-label d-block mt-3">Identification: <span className="text-danger">*</span></label>
                <div className="btn-group mb-3">
                    <select name="ID-type" className="form-select w-50 rounded-0 rounded-start" id="" onChange={(e) => {
                        setIDtype(e.target.value);
                    }}>
                        <option value="Green book">Green book</option>
                        <option selected value="Smart Card">Smart Card</option>
                        <option value="Passport">Passport</option>
                        <option value="Driver's License">Driver's License</option>
                        <option value="Worker's Permit">Worker's Permit</option>
                        <option value="Temporary ID">Temporary ID</option>
                    </select>
                    <input id="ID" name="ID" className="form-control w-100 rounded-0 rounded-end" onChange={(e) => {
                        setID(e.target.value)
                    }} value={ID}/>
                </div>
                


                <div className="d-flex flex-wrap">
                    <div className="me-3">
                        <label htmlFor="birthdate" className="form-label">Date of birth: <span className="text-danger">*</span></label>
                        <input type="date" className="form-control" onChange={(e)=> {
                            setBirthDate(e.target.value)
                        }} value={birthdate}/>
                    </div>
                    


                </div>

                <label htmlFor="email" className="form-label mt-3">Email address: <span className="text-danger">*</span></label>
                <input type="email" className="form-control" onChange={(e) => {
                    setEmail(e.target.value)
                }} value={email}/>
                
                <label htmlFor="phone" className="form-label">Phone number: <span className="text-danger">*</span></label>
                <input className="form-control" onChange={(e) => {
                    setPhone(e.target.value)
                }} value={phone}/>
                <div className="d-flex justify-content-center my-3">

                <button className="btn btn-primary" onClick={() => {
                    setType('');
                    setTypeOther('');
                    setTitle('');
                    setFirstName('');
                    setLastName('');
                    setMarital('');
                    setIDtype('');
                    setID('');
                    setBirthDate('');
                    setSex('');
                    setEmail('');
                    setPhone('');
                    setCurrentRep(currentRep + 1);
                    setShow(false);
                    setShowAnother(true);
                    window.location.replace("/#representatives");
                    
                }}>Submit representative</button>
                </div>

            </div>
            }

            {edit1 &&
            <div>
                <h2 className="display-6 text-center text-muted my-3">Company Representatives</h2>

                <h4 className="text-center">Representatives Details</h4>


                <select name="representative-type" class="form-select my-3" onChange={(e) => {
                    setType(e.target.value)
                }} value={type}>
                    <option selected>Representative type <span className="text-danger">*</span></option>
                    <option value="Director">Director</option>
                    <option value="Shareholder">Shareholder</option>
                    <option value="Employee">Employee</option>
                    <option value="Surety">Surety</option>
                    <option value="Other">Other</option>
                </select>

                <label htmlFor="other" className="form-label ms-3">If other, please specify</label>
                <input type="text" className="form-control w-50 ms-3" onChange={(e) => {
                    setTypeOther(e.target.value)
                }} value={typeother}/>
                
                <div className="d-flex">
                    <div>
                    <label htmlFor="title" className="form-label">Title: <span className="text-danger">*</span></label>
                    <select name="title" class="form-select" onChange={(e) => {
                        setTitle(e.target.value)
                    }} value={title}>
                        <option selected value="Unspecified"></option>
                        <option value="Mr.">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Miss.">Miss.</option>
                        <option value="Dr.">Dr.</option>
                        <option value="Adv.">Adv.</option>
                        <option value="Other">Other</option>
                    </select>
                    </div>
                    <div className="ms-3">
                        <label htmlFor="sex" className="form-label">Gender: <span className="text-danger">*</span></label>
                    
                        <select name="sex" id="" className="form-select" onChange={(e) => {
                            setSex(e.target.value)
                        }} value={sex}>
                            <option selected value="Unspecified"></option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Unknown">Unknown</option>
                        </select>
                    </div>

                </div>

                
                


                <div className="d-flex flex-wrap">
                    <div className="me-2">
                        <label for="firstname" className="form-label">First name: <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" onChange={(e) => {
                            setFirstName(e.target.value)
                        }} value={firstname}/>
                    </div>
                </div>
                

                <label for="lastname" className="form-label">Last name: <span className="text-danger">*</span></label>
                <input type="text" className="form-control" onChange={(e) => {
                    setLastName(e.target.value)
                }} value={lastname}/>

                <select name="marital" className="form-select w-50 mt-3" onChange={(e) => {
                    setMarital(e.target.value)
                }} value={marital}>
                    <option selected value="Not selected">Marital Status <span className="text-danger">*</span></option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Engaged">Engaged</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Unknown">Unknown</option>
                </select>

                



                <label for='ID' className="form-label d-block mt-3">Identification: <span className="text-danger">*</span></label>
                <div className="btn-group mb-3">
                    <select name="ID-type" className="form-select w-50 rounded-0 rounded-start" id="" onChange={(e) => {
                        setIDtype(e.target.value);
                    }}>
                        <option value="Green book">Green book</option>
                        <option selected value="Smart Card">Smart Card</option>
                        <option value="Passport">Passport</option>
                        <option value="Driver's License">Driver's License</option>
                        <option value="Worker's Permit">Worker's Permit</option>
                        <option value="Temporary ID">Temporary ID</option>
                    </select>
                    <input id="ID" name="ID" className="form-control w-100 rounded-0 rounded-end" onChange={(e) => {
                        setID(e.target.value)
                    }} value={ID}/>
                </div>
                


                <div className="d-flex flex-wrap">
                    <div className="me-3">
                        <label htmlFor="birthdate" className="form-label">Date of birth: <span className="text-danger">*</span></label>
                        <input type="date" className="form-control" onChange={(e)=> {
                            setBirthDate(e.target.value)
                        }} value={birthdate}/>
                    </div>
                    


                </div>

                <label htmlFor="email" className="form-label mt-3">Email address: <span className="text-danger">*</span></label>
                <input type="email" className="form-control" onChange={(e) => {
                    setEmail(e.target.value)
                }} value={email}/>
                
                <label htmlFor="phone" className="form-label">Phone number: <span className="text-danger">*</span></label>
                <input className="form-control" onChange={(e) => {
                    setPhone(e.target.value)
                }} value={phone}/>
                <div className="d-flex justify-content-center my-3">

                <button className="btn btn-primary" onClick={(e) => {
                    e.preventDefault();

                    setEdit1(false);
                    window.location.replace("/#representatives");

                    
                }}>Edit representative</button>
                </div>

            </div>
            }

            {edit2 &&
            <div>
                <h2 className="display-6 text-center text-muted my-3">Company Representatives</h2>

                <h4 className="text-center">Representatives Details</h4>


                <select name="representative-type" class="form-select my-3" onChange={(e) => {
                    setType(e.target.value)
                }} value={type}>
                    <option selected>Representative type <span className="text-danger">*</span></option>
                    <option value="Director">Director</option>
                    <option value="Shareholder">Shareholder</option>
                    <option value="Employee">Employee</option>
                    <option value="Surety">Surety</option>
                    <option value="Other">Other</option>
                </select>

                <label htmlFor="other" className="form-label ms-3">If other, please specify</label>
                <input type="text" className="form-control w-50 ms-3" onChange={(e) => {
                    setTypeOther(e.target.value)
                }} value={typeother}/>
                
                <div className="d-flex">
                    <div>
                    <label htmlFor="title" className="form-label">Title: <span className="text-danger">*</span></label>
                    <select name="title" class="form-select" onChange={(e) => {
                        setTitle(e.target.value)
                    }} value={title}>
                        <option selected value="Unspecified"></option>
                        <option value="Mr.">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Miss.">Miss.</option>
                        <option value="Dr.">Dr.</option>
                        <option value="Adv.">Adv.</option>
                        <option value="Other">Other</option>
                    </select>
                    </div>
                    <div className="ms-3">
                        <label htmlFor="sex" className="form-label">Gender: <span className="text-danger">*</span></label>
                    
                        <select name="sex" id="" className="form-select" onChange={(e) => {
                            setSex(e.target.value)
                        }} value={sex}>
                            <option selected value="Unspecified"></option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Unknown">Unknown</option>
                        </select>
                    </div>

                </div>

                
                


                <div className="d-flex flex-wrap">
                    <div className="me-2">
                        <label for="firstname" className="form-label">First name: <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" onChange={(e) => {
                            setFirstName(e.target.value)
                        }} value={firstname}/>
                    </div>
                </div>
                

                <label for="lastname" className="form-label">Last name: <span className="text-danger">*</span></label>
                <input type="text" className="form-control" onChange={(e) => {
                    setLastName(e.target.value)
                }} value={lastname}/>

                <select name="marital" className="form-select w-50 mt-3" onChange={(e) => {
                    setMarital(e.target.value)
                }} value={marital}>
                    <option selected value="Not selected">Marital Status <span className="text-danger">*</span></option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Engaged">Engaged</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Unknown">Unknown</option>
                </select>

                



                <label for='ID' className="form-label d-block mt-3">Identification: <span className="text-danger">*</span></label>
                <div className="btn-group mb-3">
                    <select name="ID-type" className="form-select w-50 rounded-0 rounded-start" id="" onChange={(e) => {
                        setIDtype(e.target.value);
                    }}>
                        <option value="Green book">Green book</option>
                        <option selected value="Smart Card">Smart Card</option>
                        <option value="Passport">Passport</option>
                        <option value="Driver's License">Driver's License</option>
                        <option value="Worker's Permit">Worker's Permit</option>
                        <option value="Temporary ID">Temporary ID</option>
                    </select>
                    <input id="ID" name="ID" className="form-control w-100 rounded-0 rounded-end" onChange={(e) => {
                        setID(e.target.value)
                    }} value={ID}/>
                </div>
                


                <div className="d-flex flex-wrap">
                    <div className="me-3">
                        <label htmlFor="birthdate" className="form-label">Date of birth: <span className="text-danger">*</span></label>
                        <input type="date" className="form-control" onChange={(e)=> {
                            setBirthDate(e.target.value)
                        }} value={birthdate}/>
                    </div>
                    


                </div>

                <label htmlFor="email" className="form-label mt-3">Email address: <span className="text-danger">*</span></label>
                <input type="email" className="form-control" onChange={(e) => {
                    setEmail(e.target.value)
                }} value={email}/>
                
                <label htmlFor="phone" className="form-label">Phone number: <span className="text-danger">*</span></label>
                <input className="form-control" onChange={(e) => {
                    setPhone(e.target.value)
                }} value={phone}/>
                <div className="d-flex justify-content-center my-3">

                <button className="btn btn-primary" onClick={(e) => {
                    e.preventDefault();

                    setEdit2(false);
                    
                    window.location.replace("/#representatives");

                    
                }}>Edit representative</button>
                </div>

            </div>
            }

            {edit3 &&
            <div>
                <h2 className="display-6 text-center text-muted my-3">Company Representatives</h2>

                <h4 className="text-center">Representatives Details</h4>


                <select name="representative-type" class="form-select my-3" onChange={(e) => {
                    setType(e.target.value)
                }} value={type}>
                    <option selected>Representative type <span className="text-danger">*</span></option>
                    <option value="Director">Director</option>
                    <option value="Shareholder">Shareholder</option>
                    <option value="Employee">Employee</option>
                    <option value="Surety">Surety</option>
                    <option value="Other">Other</option>
                </select>

                <label htmlFor="other" className="form-label ms-3">If other, please specify</label>
                <input type="text" className="form-control w-50 ms-3" onChange={(e) => {
                    setTypeOther(e.target.value)
                }} value={typeother}/>
                
                <div className="d-flex">
                    <div>
                    <label htmlFor="title" className="form-label">Title: <span className="text-danger">*</span></label>
                    <select name="title" class="form-select" onChange={(e) => {
                        setTitle(e.target.value)
                    }} value={title}>
                        <option selected value="Unspecified"></option>
                        <option value="Mr.">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Miss.">Miss.</option>
                        <option value="Dr.">Dr.</option>
                        <option value="Adv.">Adv.</option>
                        <option value="Other">Other</option>
                    </select>
                    </div>
                    <div className="ms-3">
                        <label htmlFor="sex" className="form-label">Gender: <span className="text-danger">*</span></label>
                    
                        <select name="sex" id="" className="form-select" onChange={(e) => {
                            setSex(e.target.value)
                        }} value={sex}>
                            <option selected value="Unspecified"></option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Unknown">Unknown</option>
                        </select>
                    </div>

                </div>

                
                


                <div className="d-flex flex-wrap">
                    <div className="me-2">
                        <label for="firstname" className="form-label">First name: <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" onChange={(e) => {
                            setFirstName(e.target.value)
                        }} value={firstname}/>
                    </div>
                </div>
                

                <label for="lastname" className="form-label">Last name: <span className="text-danger">*</span></label>
                <input type="text" className="form-control" onChange={(e) => {
                    setLastName(e.target.value)
                }} value={lastname}/>

                <select name="marital" className="form-select w-50 mt-3" onChange={(e) => {
                    setMarital(e.target.value)
                }} value={marital}>
                    <option selected value="Not selected">Marital Status <span className="text-danger">*</span></option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Engaged">Engaged</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Unknown">Unknown</option>
                </select>

                



                <label for='ID' className="form-label d-block mt-3">Identification: <span className="text-danger">*</span></label>
                <div className="btn-group mb-3">
                    <select name="ID-type" className="form-select w-50 rounded-0 rounded-start" id="" onChange={(e) => {
                        setIDtype(e.target.value);
                    }}>
                        <option value="Green book">Green book</option>
                        <option selected value="Smart Card">Smart Card</option>
                        <option value="Passport">Passport</option>
                        <option value="Driver's License">Driver's License</option>
                        <option value="Worker's Permit">Worker's Permit</option>
                        <option value="Temporary ID">Temporary ID</option>
                    </select>
                    <input id="ID" name="ID" className="form-control w-100 rounded-0 rounded-end" onChange={(e) => {
                        setID(e.target.value)
                    }} value={ID}/>
                </div>
                


                <div className="d-flex flex-wrap">
                    <div className="me-3">
                        <label htmlFor="birthdate" className="form-label">Date of birth: <span className="text-danger">*</span></label>
                        <input type="date" className="form-control" onChange={(e)=> {
                            setBirthDate(e.target.value)
                        }} value={birthdate}/>
                    </div>
                    


                </div>

                <label htmlFor="email" className="form-label mt-3">Email address: <span className="text-danger">*</span></label>
                <input type="email" className="form-control" onChange={(e) => {
                    setEmail(e.target.value)
                }} value={email}/>
                
                <label htmlFor="phone" className="form-label">Phone number: <span className="text-danger">*</span></label>
                <input className="form-control" onChange={(e) => {
                    setPhone(e.target.value)
                }} value={phone}/>
                <div className="d-flex justify-content-center my-3">

                <button className="btn btn-primary"  onClick={(e) => {
                    e.preventDefault();
                
                    setEdit3(false);

                    window.location.replace("/#representatives");

                }}>Edit representative</button>
                </div>

            </div>
            }
            
        </section>
     );
}
 
export default Representatives;